export const PHONE_COUNTRY_CODE = '+91';
